// countryApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Countries } from "model/countries-model";
import { ApiResponse } from "model/response-model";
import { ActivityLogModel, ActivityLogQuery } from "model/activity-log-model";
import { baseQueryWithReauth } from "./config/interceptor";

export const activityLogApi = createApi({
  reducerPath: "activityLogApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getActivityLog: builder.query<
      ApiResponse<ActivityLogModel>,
      ActivityLogQuery
    >({
      query: (query) => ({
        url: `ActivityLog/get-activity-log`,
        params: query,
      }),
    }),
  }),
});

export const { useGetActivityLogQuery } = activityLogApi;
